export default "__VITE_ASSET__D4zu2ZmO__"